import { createView } from "../../views"

const { default: FooterView } = createView('footer-view');

export const FooterCard = () => {
  return (
    <FooterView />
  )
}